// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"4ce04ba32db0afdf7f723923a90aee941e4a9fde"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/4ce04ba3";import * as Sentry from '@sentry/nextjs';

import { environment } from './environments/environment';
import project from './project.json';
import { baseClientSentryConfig } from './sentry.config';

Sentry.init({
    ...baseClientSentryConfig(environment.SENTRY),
});

Sentry.setTag(
    'project',
    environment.SENTRY.SENTRY_PROJECT_NAME ?? (project.name || 'UnknownProject'),
);
